import { useLocation } from "react-router-dom";
import { IoArrowBackSharp } from "react-icons/io5";
import { useNavigate } from "react-router-dom";

const BreadCrumbV2 = () => {
  const navigate = useNavigate();
  const location = useLocation();

  // function to split the path name
  const splitPath = location.pathname.split("/");

  // function to remove hyphens
  const removeHyphen = (inputPath: string) => {
    return inputPath.replace(/-/g, " ");
  };

  // function to go back
  const goBack = () => {
    navigate(-1);
  };

  return (
    <div>
      <div className="flex gap-2">
        <button className="focus:outline-none" onClick={goBack}>
          <IoArrowBackSharp className="text-primaryPurple-100" />
        </button>
        <div>
          <span className="text-primaryPurple-100">{removeHyphen(splitPath[1])} </span>
          <span className="text-gray-600">/ {removeHyphen(splitPath[2])}</span>
        </div>
      </div>
    </div>
  );
};

export default BreadCrumbV2;
